import { AttachmentFiles } from './AttachmentFiles'
import { AttachmentFilesGrid } from './AttachmentFilesGrid'
import { AttachmentsAccordion } from './AttachmentsAccordion'
import { HeroContentHigh } from './HeroContentHigh'
import { SavedContent } from './SavedContent'

export default {
  HeroContentHigh,
  AttachmentFiles,
  AttachmentFilesGrid,
  AttachmentsAccordion,
  SavedContent
}
